import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LogIn from './LogIn';

export default class LogInModal extends Component {

  render() {
    return (
        <div
        className="modal-event"
        >
            <div className="content-form">
                <LogIn {...this.props}/>
            </div>
        </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/features/authentification/AuthModal.js